// extracted by mini-css-extract-plugin
export default {"container":"u8M13aUO--styles_container__jRgP-","shimmer":"u8M13aUO--styles_shimmer__eg+5y"};